import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Direction from '../views/Direction.vue';
import Dojos from '../views/Dojos.vue';
import Contacts from '../views/Contacts.vue';
import RedesSociais from '../views/RedesSociais.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/direction', name: 'Direction', component: Direction },
  { path: '/dojos', name: 'Dojos', component: Dojos },
  { path: '/contacts', name: 'Contacts', component: Contacts },
  { path: '/redes-sociais', name: 'RedesSociais', component: RedesSociais },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
